var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 36,
    viewBox: "0 0 67 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 36,
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.502,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.999 4H14.18L5 13.291V18.999L6.578 20.626V28.603L5 30.229V31.999H17.8H34.999V4Z",
    fill: "#130229"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_100",
    transform: "scale(0.0149254 0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_100",
    width: 67,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAkCAMAAADl5XejAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABR1BMVEX///8XCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyIXCyI3LTe1soy/vJK+u5K+u5G+upC9upC9uY+8uY+8uI68uI27t427t4y7toy6tou6tYq5tIm5s4i4s4i4soe3soa3sYW2sYW2sIS4sYK7soC9s32/tHvCtXnEtnbHt3TJuHLLuW/Oum3Qu2vTvGnVvWbXvmTav2HcwF/fwV3hwlvkw1jmxFboxVTrxlHtx0/wyE3yykr0y0i1s4y/vJO2s42/vZM3LTjAvZS2s47AvpRqUzC3tI/AvpV3XzTBv5ZOOyxXT05iWlVCOD/Kp0HJpkIlFyTHpEUlFyW9p12nkVOpklGrk1Ctk06ulE2xlUqylkm0lke2l0WqjEGwm1wjFiatml2smV8jFif///+gphohAAAAE3RSTlMAS7Tww1pcjEDPk/sqPNu/r3MKXcGlTgAAAAFiS0dEAIgFHUgAAAAHdElNRQfmARsMBjdRTFD8AAABK0lEQVRIx+3WR1fCQBQF4BESQ7PgQ8WKUhSw9y5FRZoiHXsB+//fO8Wj4biaea483kV2+TLJ3HcmhHylw2IF+Wj6t0A6FQAeHU+AZiY8/QOD3qHhkdGxcd/EpD8QCAZDU9PhcCQ6Mzs3v7C4tLyyura+sbm1vbO7tx+LJ5IHh0f0PjOROsYYnEhnMAYjsukcxuBE/kTJOBXflBOFMyWjKPZWECU1owxg0HYKQt2wEWIRBMqgM8IIlEFfpfQnDANriH7gDNFTDaCCMPi86PRSRRrEAKhhDdu/8esGbl/qAHZkPxrnAA5cTy8uAZwuhXm5ur65vbt/aLYenxjRpTC3zy/mw5YR0sZrG9HNCFnj7Z0+u+czve4+fk5q0v8KfPlt0fEERaRWYne4fggfrrV2DH2W1OMAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.2fe398bdc68ef5702bb02d89fb4fbd7e.svg";
export { ForwardRef as ReactComponent };